import { PDFDocument } from 'pdf-lib';
import HTML2canvas from "html2canvas";
import JsPDF from "jspdf";

export class Printer {
    // `requestId` (opcional) hace que la app de impresión muestre "Volver al tótem" y responda en
    // printer_links/{instanceId} con ese mismo id (ver utils/printerLink.js).
    static async sendLinkIntent(clientId, instanceId, environment, requestId = null) {
        try {
            let deepLink = `mdprinter://setData?clientId=${encodeURIComponent(clientId)}&instanceId=${encodeURIComponent(instanceId)}&environment=${encodeURIComponent(environment)}`;
            if (requestId) deepLink += `&requestId=${encodeURIComponent(requestId)}`;
            window.location.href = deepLink;
            return true;
        } catch (error) {
            console.error('[Printer Service] Error sending link intent:', error);
            return false;
        }
    };

    static async wakeUpPrinterBridge() {
        try {
            const deepLink = 'mdprinter://wakeup';
            window.location.href = deepLink;
            return true;
        } catch (error) {
            console.error('[Printer Service] Error sending wakeup intent:', error);
            return false;
        }
    };
}